import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ValidatorFn } from '@angular/forms';
import { GlobalService } from '../services/global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-illustration-hc-exp-questionnaire',
  templateUrl: './new-illustration-hc-exp-questionnaire.component.html',
  styleUrls: ['./new-illustration-hc-exp-questionnaire.component.css']
})
export class NewIllustrationHcExpQuestionnaireComponent implements OnInit {
  profileInfo: FormGroup;
  spouseProfileInfo: FormGroup;
  healthInfo: FormGroup;
  spouseHealthInfo: FormGroup;
  isSpouse: boolean = false;

  public highBloodPressureMessage: string = 'Hypertension (high blood pressure, HiBP) is an elevation of either or both the systolic and diastolic blood pressure. Hypertension is defined as systolic BP >139 mmHg and/or diastolic BP >89 mmHg.';
  public highCholesterolMessage: string = "Cholesterol levels are considered elevated when greater than 200 milligrams/dL and LDL levels greater than 100 mg/dL.";
  public type2DiabetesMessage: string = "A chronic disease in which carbohydrate (sugar) metabolism is impaired due to an absolute or relative insufficiency of insulin. Type 2 is non-autoimmune and is due to peripheral insulin resistance.";
  public cardiovascularDiseaseMessage: string = "Diseases of the heart, arteries or veins. Common cardiovascular diseases include arteriosclerosis, coronary artery disease, heart valve disease, arrhythmias, heart failure, myocarditis, myocardiopathy, congenital heart disease, and pulmonary emboli.";
  public tobaccoMessage: string = "Use of pipes, cigars, snuff, smokeless tobacco or cigarettes.";
  public cancerMessage: string = "Two characteristic features define a cancer. The first is cells are abnormal (malignant) and their growth is not regulated as are normal cells. The second is the capacity of the cells to invade tissues and metastasize to both local and distant sites.";
  public multipleSclerosisMessage: string = "Immune-mediated inflammatory disease of the central nervous system characterized by inflammation of the myelin sheath surrounding the axons (nerve fibers) of the brain and spinal cord.";
  public type1DiabetesMessage: string = "A chronic disease in which carbohydrate (sugar) metabolism is impaired due to an absolute or relative insufficiency of insulin. Type 1 is autoimmune (Beta cells destroyed) and occurs at younger ages.";
  public familyHistoryMessage: string = "An individual’s direct ancestors (e.g., parents, grandparents, aunts, uncles) have been diagnosed with Diabetes or Cardiovascular Disease.";
  public dependentCaneWalkerMessage: string = "An individual is reliant on a cane, walker, or wheelchair for mobility.";

  constructor(private router: Router, private globalService: GlobalService,) { }

  ngOnInit() {

    const youngerThanValidator = (minAge: number, maxAge: number): ValidatorFn => control =>
      //cant be older than max
      (this.globalService.calculateAgeV2(control.value)) > maxAge 
      //cant be younger than min
      || (this.globalService.calculateAgeV2(control.value)) < minAge   
        ? {invalidDate: 'Please make sure age is between ' + minAge + ' and ' + maxAge + '.' }  
        : null;

    this.profileInfo = new FormGroup({
      firstName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(30), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
      lastName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(30), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
      gender: new FormControl('', [Validators.required]),
      dob: new FormControl('', [Validators.required, youngerThanValidator(18, 80)]),
      // retirementAge: new FormControl('', [Validators.required]),
      // retirementState: new FormControl('', [Validators.required]),    
      //TODO: need to save this new value
      runReportWithSpouse: new FormControl(false),
      //TODO: base this on the marital status and if there is a spouse object
      isLegalSpouse: new FormControl(false),
      maritalStatus: new FormControl()
    });
  
    this.spouseProfileInfo = new FormGroup({
      firstName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(30), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
      lastName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(30), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
      gender: new FormControl('', [Validators.required]),
      dob: new FormControl('', [Validators.required, youngerThanValidator(18, 80)]),
      // retirementAge: new FormControl('', [Validators.required]),
      // retirementState: new FormControl('', [Validators.required]),   
      maritalStatus: new FormControl()
    });
    this.healthInfo = new FormGroup({
      highBP: new FormControl(false),
      highChol: new FormControl(false),
      //TODO: type1 is not being return from API - need to update API
      type1Diab: new FormControl(false),
      type2Diab:  new FormControl(false),
      cardioDisease:  new FormControl(false),
      cancer:  new FormControl(false),
      multSclerosis: new FormControl(false), //TODO: need to get returned per client from API
      tobacco:  new FormControl(false),
      depCaneWalker: new FormControl(false), //TODO: need to get returned per client from API
      famHistory: new FormControl(false), //TODO: need to get returned per client from API
      lifeExp: new FormControl(89) //TODO: this should be prepopulating a drodown - no need for validation
    });
    this.spouseHealthInfo = new FormGroup({
      highBP: new FormControl(false),
      highChol: new FormControl(false),
      //TODO: type1 is not being return from API - need to update API
      type1Diab: new FormControl(false),
      type2Diab:  new FormControl(false),
      cardioDisease:  new FormControl(false),
      cancer:  new FormControl(false),
      multSclerosis: new FormControl(false), //TODO: need to get returned per client from API
      tobacco:  new FormControl(false),
      depCaneWalker: new FormControl(false), //TODO: need to get returned per client from API
      famHistory: new FormControl(false), //TODO: need to get returned per client from API
      lifeExp: new FormControl(89)//TODO: this should be prepopulating a drodown - no need for validation
    });
  }

  onSelectSpouse() {
    /* if (this.profileInfo.value.isLegalSpouse == 1) {
      console.log('has spouse');
      this.isSpouse = true;
    } else {
      this.isSpouse = false;
    } */

      this.isSpouse = (this.profileInfo.value.runReportWithSpouse);
  }

  redirectHCExpIllustration() {
    // this.router.navigate(['/reports/create/hcexpress']);
    console.log('this.profileInfo')
    console.log(this.profileInfo);
    let profileInfo = {
      dob: this.profileInfo.value.dob,
      firstName: this.profileInfo.value.firstName,
      lastName: this.profileInfo.value.lastName,
      gender: this.profileInfo.value.gender,
      maritalStatus: this.spouseProfileInfo.value.firstName ? true : false
    };
    let spouseProfileInfo = {
      dob: this.spouseProfileInfo.value.dob,
      firstName: this.spouseProfileInfo.value.firstName,
      lastName: this.spouseProfileInfo.value.lastName,
      gender: this.spouseProfileInfo.value.gender
    };
    
    this.router.navigate(['/hc-express-questionnaire/hcexpress'], { 
      state: { 
        profileInfo: profileInfo, 
        healthInfo: this.healthInfo.value, 
        spouseProfileInfo: spouseProfileInfo, 
        spouseHealthInfo: this.spouseHealthInfo.value 
      } 
    });
  }

  onDateChange() {
    if (this.spouseProfileInfo.value.dob && this.profileInfo.value.dob) {
      let spouseDOB = new Date(this.spouseProfileInfo.value.dob);
      spouseDOB.setFullYear(spouseDOB.getFullYear() + 18);
      let clientDOB = new Date(this.profileInfo.value.dob);
      clientDOB.setFullYear(clientDOB.getFullYear() + 18);
      //this.minMarriedDate = spouseDOB > clientDOB ? spouseDOB : clientDOB;
      //console.log('this.minMarriedDate', this.minMarriedDate);
      //this.clientAge = this.calculateAge(this.profileInfo.value.dob);
      //this.spouseAge = this.calculateAge(this.spouseProfileInfo.value.dob);
    } else {
      //this.clientAge = 0;
      //this.spouseAge = 0;
    }
  }

}
